import { ActionTypes } from "../../constants/ActionTypes";
import { ILetterBody } from "../../interfaces";

// letterBody
export const onGetLetterBody = (letterCode: string | undefined) => {
    return {
        letterCode: letterCode,
        type: ActionTypes.GET_LetterBody,
    };
};

export const fetchLetterBodySuccess = (letterBody: ILetterBody[]) => {
    return {
        type: ActionTypes.FETCH_LetterBody_SUCCESS,
        payload: letterBody,
    };
};




